/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-12-05 10:12:54
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-11 18:21:30
 * @FilePath: /dbrank_b/src/routes/cms/components/BrandComponent/BrandManage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import NavComponent from '../NavComponent';
import { Button } from '../FormElement';
import { getBrandTree, getBrandWords, updateWords } from '../../../../controller';
import PropTypes from 'prop-types';
import BrandManageGroup from './BrandManageGroup';
import { colors } from '../confog';

const itemColors = ['#ebedf0', ...colors]
const transform = (data) => {
  const { brandId, brandName, industryId, ...words } = data

  return {
    brandId,
    brandName,
    industryId,
    list: Object.keys(words).map(label => ({
      label,
      // 字符串转数组并去重
      value: words[label] ? [...new Set(words[label].split(','))] : [],
    }))
  };
}

const transformNewData = (data) => {
  const list = data.list;
  
  return {
    ...data,
    list: list.map(item => {
      return {
        ...item,
        value: item.values ? item.values.split(',') : []
      }
    })
  }
}

const getTeeePath = (tree, id, path) => {
  for( let i = 0; i < tree.length; i++ ) {
    const ele = tree[i];
    const brandId = `${ele.brandId || ele.brand_id}`;
    const idStr = `${id}`;
    const innerPath = `${path}_${i}`;

    if (brandId === idStr) {
      return innerPath
    }
    if (Array.isArray(ele.children) && ele.children.length > 0) {
      const a = getTeeePath(ele.children, id, innerPath)
      if (a) {
        return a;
      }
    }
  }
}

const resetTree = (tree, deep, path) => {
  return tree.map((item, index) => {
    // console.log(item, path[deep], `${index}`);
    const newItem = {
      ...item,
      expand: path[deep] === `${index}`,
    }

    if (Array.isArray(newItem.children) && newItem.children.length) {
      newItem.children = resetTree(newItem.children, deep + 1, path);
    }

    return newItem;
  })
}
// const getCurrentNav = (list) => {
//   list.filter()
// }
class BrandManage extends React.PureComponent {
  static propTypes = {
    brandId: PropTypes.string,
  }
  state = {
    isEdit: false,
    tree: [],
    dataList: [],
    navData: {
      brandId: '',
      industryId: '',
      industryName: ''
    }
  }

  componentDidMount() {
    const { brandId } = this.props;
    if (brandId) {
      this.getBrandTree({ brandId })
    }
  }

  toggle = () => {
    const { isEdit, navData } = this.state;

    if (isEdit) {
      const res = confirm('是否取消编辑');
      if (!res) {
        return;
      }
      this.getBrandWords({ ...navData })
    }
    this.setState({
      isEdit: !isEdit,
    });
  }

  brandChange = (data, deepIndex, currentKey) => {
    this.setState({
      navData: {
        brandId: data.brandId,
        industryId: data.industryId,
        industryName: data.industryName
      },
      isEdit: false,
      // tree: newTree
    });

    this.getBrandWords({
      brandId: data.brandId,
      industryId: data.industryId,
      industryName: data.industryName
    })
  }

  getBrandTree = (data) => {
    this.setState({ loading: true })

    getBrandTree({
      // brandId:7,
      ...data,
    }).then(res => {
      try {
        const nav = JSON.parse(res);
        let tree = nav ? [nav] : [];
        const path = getTeeePath(tree, data.brandId, 't');
        const pathList = (path || '').replace('t_', '').split('_');
        tree = resetTree(tree, 0, pathList);

        this.setState({
          isEdit: false,
          tree,
          defaultNav: '',
        })
        this.getBrandWords({
          ...data,
        })
      } catch (err) {
        console.log(err);
      }
      this.setState({ loading: false })
    });
  }

  getBrandWords =  (data) => {
    getBrandWords(data)
      .then(res => {
        try {
          const resData = JSON.parse(res);
          // const { tree } = this.state;

          const level = Array(5).fill('').map((e, i) => {
            const innerData = resData[`level${i}`]
            if (innerData) {
              // return transform(innerData)
              return transformNewData(innerData)
            }
            return null;
          }).filter(Boolean);

          // console.log('--00000---', level);

          this.setState({
            dataList: level,
            // dataList: [
            //   transform({
            //     brandId: tree[0].brandId,
            //     brandName: '',
            //     全站通用排除词: resData['全站通用排除词'] || '',
            //     实时监测关键词: resData['实时监测关键词'] || '',
            //   }),
            //   ...level,
            // ],
          });
        } catch(err) {
          console.log('获取关键词失败', err);
        }
      })
  }

  onChange = (type, name, { deep, index }, dataIndex) => {
    const { dataList } = this.state;
    const newData = [...dataList];
    const currentData = newData[dataIndex];

    const list = currentData.list

    const currentValues = list[deep].value;
    if (type ===  'del') {
      list[deep].value = currentValues.filter((e, i) => i !== index);
    } else if (type === 'add') {
      const val = (name || '').split(/,|，|、/).filter(Boolean);
      list[deep].value = [...currentValues, ...val];
    }

    currentData.list = list;
    newData[dataIndex] = currentData;;

    this.setState({
      dataList: newData,
    })
  }

  save = (index, dataIndex) => {
    const res = confirm('是否保存修改')
    const { dataList, navData } = this.state;
    const currentData = dataList[dataIndex]
    const { brandId, brandName, industryId, list } = currentData;

    if (res) {
      const current = list[index];
      const result = {
        brandId,
        brandName,
        industryId: industryId,
        key: current.label,
        words: (current.value || []).join(','),
      };

      updateWords(result).then(res => {
        try {
          const data = JSON.parse(res);
          if (data.incomplete_results === false) {
            alert('保存成功');
            this.getBrandWords({ ...navData })
            return;
          }
        }catch(err){
          console.log('保存失败', err);
        }
        alert('保存失败');
      });
    }
  }

  render() {
    const { isEdit, tree, loading, dataList } = this.state;
    const { brandId } = this.props;

    return (
      <div className={s.content} style={{ minHeight: 200 }}>
        <div className={s.navWrapper}>
          <NavComponent defaultBrand={brandId} tree={tree || []} onChange={this.brandChange} />
        </div>

        <div className={s.wrapper}>
          <div className={s.tipWrap}>
            <p className={s.tipText}>请在编辑和添加关键词结束后点击保存按钮完成当前修改操作</p>           
            {/* <Button onClick={this.save} style={{ marginRight: 10, display: isEdit ? 'inline-block' : 'none' }}>保存修改</Button> */}
            {tree.length > 0 && <Button onClick={this.toggle}>{!isEdit ? '编辑' : '取消编辑'}</Button>}
          </div>

          <div>
            {dataList.map((item, dataIndex) => (
              <BrandManageGroup
                style={{ borderColor:itemColors[dataIndex],  boxShadow: `inset 0 0 5px ${itemColors[dataIndex]}, 0 0 5px ${itemColors[dataIndex]};` }}
                isEdit={isEdit}
                key={dataIndex}
                title={item.brandName}
                list={item.list}
                onChange={(type, name, { deep, index }) => {
                  this.onChange(type, name, { deep, index }, dataIndex)
                }}
                onSave={(index) => {
                  this.save(index, dataIndex)
                }}
              />
            ))}
          </div>
        </div>

        <div className={s.loading} style={{ display: loading ? 'block' : 'none'}}>
          loading...
        </div>
      </div>
    )
  }
}

export default withStyles(s)(BrandManage)



// WEBPACK FOOTER //
// src/routes/cms/components/BrandComponent/BrandManage.js